import React from "react";
import { useDispatch } from "react-redux";

import AuthForm from "../views/authentication/AuthForm";
import { toggleModal } from "../shared-components/modals/actions";
import { useTrans } from "./useTrans";

export const useSignupModal = () => {
  const dispatch = useDispatch();
  const { trans } = useTrans();
  const signupTitle = trans(
    "Sign up to comment and interact with the largest storytelling community"
  );

  const createAuthForm = ({ eventSource }) => {
    return (
      <AuthForm
        nextUrl={window.location.href}
        title={signupTitle}
        eventSource={eventSource}
      />
    );
  };

  const openSignupModal = (classes = "", eventSource) => {
    dispatch(
      toggleModal({
        className: `signup-modal ${classes}`,
        disableScroll: true,
        useGlobalModalContainer: true,
        component: () => createAuthForm({ eventSource })
      })
    );
  };

  return { openSignupModal };
};
